// src/pages/account/ContinentalTransactionDetails.jsx
import React from 'react';
import TransactionDetails from '../TransactionDetails';

const ContinentalTransactionDetails = () => {
  return <TransactionDetails locationKey="continental" />;
};

export default ContinentalTransactionDetails;